// components
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import { ClaMaintenanceDrawer } from './components/ClaMaintenanceDrawer/ClaMaintenanceDrawer';

// hooks
import { useColumnDefinitions } from './ClaMaintenance.utils';
import { useClaMaintenance } from './ClaMaintenance.hooks';

const ClaMaintenance = () => {
  const { clas, isLoading, isError, refetch } = useClaMaintenance();
  const columns = useColumnDefinitions();

  return (
    <TableCRUDLayout
      loading={isLoading}
      columns={columns}
      FormComponent={ClaMaintenanceDrawer}
      onClose={refetch}
      rows={clas}
      getRowId={(resource) => resource.claId}
      hasLoadingError={isError}
      onLoadingError={refetch}
    />
  );
};

export default ClaMaintenance;
